export default function Pagination({
	page,
	pageCount,
	onPrev,
	onNext,
}: {
	page: number;
	pageCount: number;
	onPrev: () => void;
	onNext: () => void;
}) {
    if (pageCount <= 1) return null;
    
	return (
		<div className="p-4 flex items-center justify-between bg-white border-t pt-4">
			<button
				onClick={onPrev}
				disabled={page <= 1}
				className="inline-flex items-center gap-1.5 rounded-lg border   px-3 py-2 text-sm font-medium text-foreground shadow-sm transition-all hover:bg-accent disabled:pointer-events-none disabled:opacity-50"
			>
				<svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
					<path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
				</svg>
				Previous
			</button>

			<div className="flex items-center gap-1.5 text-sm">
				<span className="text-muted-foreground">Page</span>
				<span className="rounded-md bg-muted px-2 py-0.5 font-medium text-foreground">{page}</span>
				<span className="text-muted-foreground">of</span>
				<span className="font-medium text-foreground">{pageCount}</span>
			</div>

			<button
				onClick={onNext}
				disabled={page >= pageCount}
				className="inline-flex items-center gap-1.5 rounded-lg border   px-3 py-2 text-sm font-medium text-foreground shadow-sm transition-all hover:bg-accent disabled:pointer-events-none disabled:opacity-50"
			>
				Next
				<svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
					<path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
				</svg>
			</button>
		</div>
	);
}